import { Component, OnInit, Input } from '@angular/core';
import { SearchComponent } from '../../components/common/search/search.component';
import { CompetitorSearchModel, CompetitorDto, AwardDto } from '../../models/competitors/competitor.models';
import { CompetitorService } from '../../services/competitor.service';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { IPage } from '../../models/common/paging';

@Component({
    selector: 'base-competitors',
    template: ''
})
export class BaseCompetitorsComponent extends SearchComponent<CompetitorSearchModel, CompetitorDto>{

    viewedCompany: string;
    competitorAwards: IPage<AwardDto>;

    constructor(private readonly competitorService: CompetitorService, configuration: Configuration, helpers: Helpers) {
        super(new CompetitorSearchModel(configuration), competitorService, helpers);
    }

    getCompanyAwards(competitorname: string) {
        this.viewedCompany = competitorname;
        this.competitorService.getAwardsForCompany(competitorname).subscribe((response: IPage<AwardDto>) => {
            this.competitorAwards = response;
        });
    }

    async hasCompetitors() {
        await this.competitorService.getCompetitors().subscribe((response: string[]) => {
            var result = response;
            if (result.length > 0) {
                return true;
            }
            else {
                return false;
            }
        });
    }

    //view(name: string) {
    //    this.getCompanyAwards(name);
    //    $('#view-modal').modal();
    //}
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/base.competitors.component.ts